import React, { useEffect, useState } from 'react';

const SessionLogs: React.FC = () => {
    const [sessions, setSessions] = useState<string[]>([]);
    const [selectedSession, setSelectedSession] = useState<string>('');
    const [logContent, setLogContent] = useState<string>('');
    const [eventSource, setEventSource] = useState<EventSource | null>(null);
    const [autoScroll, setAutoScroll] = useState<boolean>(true);

    useEffect(() => {
        fetchSessions();
    }, []);

    useEffect(() => {
        if (selectedSession) {
            startStreaming(selectedSession);
        }

        return () => {
            if (eventSource) {
                eventSource.close();
            }
        };
    }, [selectedSession]);

    const fetchSessions = async () => {
        try {
            const response = await fetch('https://interim-cabdemo-module.ispgnet.com/get_sessions');
            const data = await response.json();
            if (data && data.session_ids) {
                setSessions(data.session_ids);
            } else {
                console.error('Invalid response structure:', data);
            }
        } catch (error) {
            console.error('Error fetching sessions:', error);
        }
    };

    const startStreaming = (sessionId: string) => {
        if (!sessionId) return;

        setLogContent('🔄 Connecting to session logs...\n');

        const baseUrl = 'https://interim-cabdemo-module.ispgnet.com';
        const newEventSource = new EventSource(`${baseUrl}/stream/${sessionId}`);
        setEventSource(newEventSource);

        newEventSource.onmessage = (event) => {
            setLogContent((prevContent) => prevContent + event.data + '\n');
            if (autoScroll) {
                const logContainer = document.getElementById('logContent');
                if (logContainer) {
                    logContainer.scrollTop = logContainer.scrollHeight;
                }
            }
        };

        newEventSource.onerror = () => {
            setLogContent((prevContent) => prevContent + '\n⚠️ Connection lost. Trying to reconnect...\n');
        };
    };

    const handleSessionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const sessionId = event.target.value;
        setSelectedSession(sessionId);
    };

    return (
        <div className="container">
            <h2 className="text-center text-xl font-semibold py-4">Real-Time Session Logs</h2>

            <div className="mb-3">
                <label htmlFor="sessionDropdown" className="form-label">Select a Session:</label>
                <select
                    id="sessionDropdown"
                    className="form-select"
                    value={selectedSession}
                    onChange={handleSessionChange}
                >
                    <option value="">-- Select a Session --</option>
                    {sessions.map((session) => (
                        <option key={session} value={session}>{session}</option>
                    ))}
                </select>
            </div>
            {selectedSession && (
                <>
                    <h4>Live Log Output - Session ID: {selectedSession}</h4>
                    <div id="logContent" className="log-container">
                        {logContent}
                    </div>
                </>
            )}
        </div>
    );
};

export default SessionLogs;

const styles = `
    body {
        background-color: #f8f9fa;
    }
    .container {
        max-width: 1400px;
        margin-top: 40px;
    }
    #logContent {
        background-color: #212529;
        color: #f8f9fa;
        border-radius: 8px;
        padding: 15px;
        height: 550px; /* Increased height */
        overflow-y: auto;
        font-family: monospace;
        white-space: pre-wrap;
    }
    .form-select {
        height: 38px; /* Match Bootstrap input height */
    }
    .text-center {
        text-align: center;
    }
    .mb-4 {
        margin-bottom: 1.5rem;
    }
    .mb-3 {
        margin-bottom: 1rem;
    }
    .form-label {
        margin-bottom: 0.5rem;
    }
`;

// Inject styles into the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
